<template>
    <div class="row">
        <div class="col-6">
            <p class="el-style attribute-name">Description:</p>
            <p>{{ description }}</p>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-3">
                    <p class="el-style attribute-name">Key:</p>
                    <p class="el-style attribute-name">Created:</p>
                    <p class="el-style attribute-name">Updated:</p>
                </div>
                <div class="col-9">
                    <p>{{ key }}</p>
                    <p>{{ createdAt }}</p>
                    <p>{{ updatedAt }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {string}
       */
      key() {
        return _.get(this.row, 'model.key');
      },

      /**
       * @return {string}
       */
      createdAt() {
        return this.formatDate(_.get(this.row, 'model.created_at.datetime'));
      },

      /**
       * @return {string}
       */
      updatedAt() {
        return this.formatDate(_.get(this.row, 'model.updated_at.datetime'));
      },

      /**
       * @return {string}
       */
      description() {
        return _.get(this.row, 'model.description') || '-';
      },
    },

    methods: {
      /**
       * @param {object} val
       * @return {string}
       */
      formatDate(val) {
        return moment(val).format(config('format.moment.short.datetime'));
      },
    },
  }
</script>

